module.exports = __webpack_public_path__ + "media/application/images/icons/share-ed7a0911373925588f3dbb3af5083769.svg";